import React from 'react';
import { validateIframeRegex } from '../../../../../../../../../helper/validators';

const renderContent = (src, type) => {
  if (type === 'url') {
    return (
      <div className="embed--url_block" style={{ width: '100%' }}>
        <div className="embed--url_iFrame">
          <iframe title="URL" src={src} width="100%" height="900" />
        </div>
      </div>
    );
  }
  if (type === 'embedly') {
    const data = JSON.parse(src);

    if (data.type === 'video') {
      return (
        <div
          className="embedBlockIframeContainer"
          dangerouslySetInnerHTML={{ __html: data.html }}
        />
      );
    }
    if (data.type === 'link') {
      let renderImageLink = '';
      if (data.url) {
        renderImageLink = (
          <a href={data.url} target="_blank">
            <img
              src="https://dndw32r4edmw5.cloudfront.net/lyearn/assets/embed_thumb_image.png"
              alt=""
            />
          </a>
        );
      } else {
        renderImageLink = (
          <img
            src="https://dndw32r4edmw5.cloudfront.net/lyearn/assets/embed_thumb_image.png"
            alt=""
          />
        );
      }
      return (
        <div className="embed embed--link embed--rich">
          {!!data.url && !!data.thumbnail_url && (
            <a href={data.url} rel="noopener noreferrer" target="_blank">
              <img alt="" className="embed__img" src={data.thumbnail_url} />
            </a>
          )}
          {!data.hideMetadata && (
            <div className="embed__meta__content">
              {!!data.url && (
                <h2 className="embed__title brand--head">
                  <a
                    href={data.provider_url}
                    rel="noopener noreferrer"
                    target="_blank"
                    className=""
                  >
                    {data.title}
                  </a>
                </h2>
              )}
              {!!data.description && (
                <p className="embed__description brand--body brand--linkColor">
                  {data.description}
                </p>
              )}
              {!data.description && (
                <p className="embed__empty_description_image brand--body">{renderImageLink}</p>
              )}
              {data.provider_name && (
                <a
                  className="embed__readMore"
                  href={data.provider_url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Read more
                  {' '}
                  {data.provider_name}
                </a>
              )}
            </div>
          )}
        </div>
      );
    }
  } else if (type === 'iframe') {
    return <div className="embedBlockIframeContainer" dangerouslySetInnerHTML={{ __html: src }} />;
  } else if (type === 'richContent') {
    const data1 = JSON.parse(src);
    const isIframe = validateIframeRegex.test(data1.embedlyData.html);
    if (isIframe) {
      return (
        <div
          className="embedBlockIframeContainer"
          dangerouslySetInnerHTML={{ __html: data1.embedlyData.html }}
        />
      );
    }
    return <iframe title="Rich Content" src={data1.userInput} width="706" height="900" />;
  }
  return null;
};

const wrapperStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'
};

export default (props) => {
  const lesson = props.lesson;
  const item = lesson.items[0];

  // const settings = lesson.settings;

  return (
    <div className="block-embed">
      <div className="">
        <div style={wrapperStyle}>{renderContent(item.media.embed.src, item.media.embed.type)}</div>
      </div>
    </div>
  );
};
